import { DocumentListCard, SkeletonDots } from '@yes.technology/react-toolkit'
import {
  CardContainer,
  ColumnCard,
  ColumnContainer,
  ColumnsContainer
} from '../KanbanAutoColumns/KanbanAutoColumns.styles'

interface KanbanSkeletonProps {
  pageColumns: number
}

const KanbanSkeleton = ({ pageColumns = 1 }: KanbanSkeletonProps) => {
  return (
    <ColumnsContainer>
      {[...Array(pageColumns)].map((_, index) => (
        <ColumnContainer key={index} $basis={Math.round(100 / pageColumns)}>
          <ColumnCard>
            <SkeletonDots size={4} />
            <CardContainer $isFadingIn={false} $isFadingOut={false}>
              <DocumentListCard
                style={{
                  padding: '16px 8px 8px',
                  border: '1.5px solid #BCBCBE'
                }}
              >
                <SkeletonDots size={4} />
              </DocumentListCard>
            </CardContainer>
          </ColumnCard>
        </ColumnContainer>
      ))}
    </ColumnsContainer>
  )
}

export default KanbanSkeleton
